export default function ({ width, stroke }) {
  return (
    <svg
      width={width}
      stroke={stroke}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3334 8.73333V9.5C18.3323 11.297 17.7504 13.0456 16.6745 14.4849C15.5985 15.9241 14.0861 16.9771 12.3628 17.4866C10.6395 17.9961 8.79774 17.9349 7.11208 17.3122C5.42642 16.6894 3.98723 15.5384 3.00915 14.0309C2.03108 12.5234 1.56651 10.7401 1.68475 8.94693C1.80299 7.1538 2.49769 5.44694 3.66525 4.08089C4.83281 2.71485 6.41068 1.76282 8.16351 1.36679C9.91635 0.970757 11.7502 1.15195 13.3917 1.88333M18.3334 2.83333L10 11.175L7.50003 8.675"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
